import React, {useState} from 'react';
import './timeButton.scss';
import axios from 'axios';
import {useMeetingAppDispatch, useMeetingAppState} from '../eventSlotSelectionApp.store';
import {TimeButtonProps} from './index';

const TimeButton: React.FC<TimeButtonProps> = ({occurrence}) => {
  const meetingDispatch = useMeetingAppDispatch();
  const {selectedTimeSlot, meeting, order_entry_id, adminOrderId} = useMeetingAppState();
  const date = new Date(occurrence.from);
  const buttonText = date.toLocaleTimeString().substring(0, 5);
  const isActive = selectedTimeSlot?.from === occurrence.from;
  const meetingId = meeting.event.id;
  const [isLoading, setLoading] = useState(false);

  const isAddToCartMode = order_entry_id === undefined;

  const submit = function () {
    const postData = {
      item: meetingId,
      start_time: occurrence.from,
      order: adminOrderId
    };

    setLoading(true);

    if (isAddToCartMode) {
      axios
        .post(`${nautilusApi.root}nautilus/v1/order-entries/add`, postData, {
          headers: {'X-WP-Nonce': nautilusApi.nonce}
        })
        .then(() => {
          if (adminOrderId) {
            window.location.reload();
          } else {
            window.location.href = `${nautilusApi.home}/page_cart/`;
          }
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      axios
        .post(
          `${nautilusApi.root}nautilus/v1/order-entries/edit`,
          {
            start_time: occurrence.from,
            nautilus_order_entry: parseInt('' + order_entry_id)
          },
          {
            headers: {'X-WP-Nonce': nautilusApi.nonce}
          }
        )
        .then(() => {
          window.location.reload();
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };

  return (
    <div
      className={
        'time-button mb-2' +
        (isActive ? ' selected-time' : '') +
        (occurrence.is_available ? '' : ' was-bookable')
      }
    >
      <button
        type={'button'}
        tabIndex={isActive ? -1 : 0}
        className={'py-3 btn btn-outline-' + (occurrence.is_available ? 'primary' : 'primary')}
        disabled={!occurrence.is_available}
        onClick={() =>
          meetingDispatch({
            type: 'ON_SELECT_OCCURRENCE',
            payload: occurrence
          })
        }
      >
        <span className={'buttonText'}>{buttonText}</span>{' '}
        {occurrence.is_available ? '' : 'ausgebucht'}
      </button>
      {isLoading ? (
        <button
          className="py-3 btn w-50 btn-primary d-inline-flex align-items-center justify-content-center"
          type="button"
          disabled
        >
          <span
            className="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          />
          Prüfe...
        </button>
      ) : (
        <button
          type={'button'}
          tabIndex={isActive ? 0 : -1}
          className={'py-3 btn w-50 btn-primary'}
          onClick={submit}
        >
          {isAddToCartMode ? 'Bestätigen' : 'Übernehmen'}
        </button>
      )}
    </div>
  );
};

export default TimeButton;
